import React, { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { SelectionProviderDisconnect as SelectionProviderDisconnectType } from "../../../../types/customization/configuration";
import { SelectionProvider, UserInfos } from "../../../../types/selection/selection";
import "./style.scss";

const SelectionProviderDisconnect: FunctionComponent<{
  userInfos: UserInfos;
  selectionProviderDisconnect: SelectionProviderDisconnectType;
  provider: SelectionProvider;
}> = ({ userInfos, selectionProviderDisconnect, provider }) => {
  return (
    <div className="SelectionProviderDisconnect">
      <img className="SelectionProviderDisconnect-picture" src={userInfos.picture} alt="" />
      <div className="SelectionProviderDisconnect-infos">
        <FormattedMessage
          id="kustom_SelectionProviderDisconnect_google__connected"
          values={{ email: userInfos.email }}
        />
      </div>
      <button
        className="SelectionProviderDisconnect-button"
        onClick={() => selectionProviderDisconnect(provider)}
      >
        <FormattedMessage id="kustom_SelectionProviderDisconnect_google__disconnect" />
      </button>
    </div>
  );
};

export default SelectionProviderDisconnect;
